import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModalComponent } from './alert-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { PlaceholderReplacePipe } from "../../../../shared/pipes/placeholder-replace/placeholder-replace.pipe";

@NgModule({
  declarations: [
    AlertModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PlaceholderReplacePipe
],
  exports: [
      AlertModalComponent
  ]
})
export class AlertModule { }
